// How the app's search boxes match: every typed word must start one of the
// thing's words, so "neth" finds the windmill and "board games" the controller.
// A trailing "s" is dropped from what's typed, so "gifts" still finds a tag
// written "gift". `words` is lowercase, each word with a space in front.
export const matchWords = (words: string, query: string) =>
    query.toLowerCase().split(/\s+/).filter(Boolean)
        .every(q => words.includes(' ' + (q.length > 3 ? q.replace(/s$/, '') : q)))
